import modelsResolver from 'utils/api/models/utils/modelsResolver';

type ResourceCharacteristicValue = {
	name: string;
	value: string;
};

type ResourceSpecification = {
	name: string;
};

type SingleResource = {
	resourceCharacteristicValue: ResourceCharacteristicValue;
	resourceSpecification: ResourceSpecification;
};

export type Resources = {
	_resources: any;
	resources: SingleResource[];
};

const model: types.models.InputModel = {
	_resources: ['response.getResourcesResponse.resource', []],
	resources: (model: Resources) => {
		const res = Array.isArray(model._resources) ? model._resources : Array(model._resources);
		return res.map((singleResource: any) => modelsResolver(singleResource, 'singleResource'));
	},
};

export default model;
